window.initEpxCalc = function (root = document) {
  root.querySelectorAll('[data-epx-calc]').forEach(initCalc);
};

function initCalc(calc) {
  if (calc.dataset.ready) return;
  calc.dataset.ready = '1';

  const len = calc.querySelector('[data-epx="len"]');
  const wid = calc.querySelector('[data-epx="wid"]');
  const hei = calc.querySelector('[data-epx="hei"]');
  const fac = calc.querySelector('[data-epx="factor"]');
  const grams = calc.querySelector('[data-epx="grams"]');
  const kg = calc.querySelector('[data-epx="kg"]');

  function calcIt() {
    const g = (+len.value || 0) * (+wid.value || 0) * (+hei.value || 0) * (+fac.value || 1.09);
    grams.textContent = Math.round(g).toLocaleString('de-CH') + ' g';
    kg.textContent = (g / 1000).toFixed(2).replace('.', ',') + ' kg';
  }

  calc.querySelector('[data-epx="calc"]').addEventListener('click', calcIt);
  calc.querySelector('[data-epx="reset"]').addEventListener('click', () => {
    len.value = wid.value = hei.value = '';
    fac.value = '1.09';
    grams.textContent = kg.textContent = '–';
  });
}

// Initial für normale Seiten
document.addEventListener('DOMContentLoaded', () => {
  window.initEpxCalc();
});